export default __webpack_public_path__ + "static/media/stars.1322dc3e.svg";